import { ApplicationState } from '../../redux/state';
import { connect } from 'react-redux';
import Result from './Result';
import {  Dispatch } from "redux";
import { getPDFFile } from '../../redux/product/productActions';


const mapStateToProps = (state : ApplicationState) => ({
    //calculationOutputData: state.product.currentProduct.calculationOutputData,
    //productData: state.product.currentProduct.productData
    currentProduct: state.product.currentProduct,
    productInputData: state.product.productInputData,
    language: state.language
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getPDFFile: () => { dispatch(getPDFFile()); }
});

const ConnectedResult = connect(mapStateToProps, mapDispatchToProps)(Result);

export default ConnectedResult;